import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {AgentDto} from "../../../../../am/model/dto/entity/agent.dto";
import {TicketService} from "../../../../service/api/ticket.service";
import {AgentService} from "../../../../../am/service/api/agent.service";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {ObjectIdentifierData} from "../../../../../../core/shared/basic/object-identifier-data";
import {MvsObjectNavigationEntry} from "../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {MvsObjectNavigationService} from "../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {QlQueryDto} from "../../../../../../core/shared/ql/data/dto/ql-query.dto";
import {QlExportPipeDto} from "../../../../../../core/shared/ql/data/dto/ql-export-pipe.dto";
import {QlRequestDto} from "../../../../../../core/shared/ql/data/dto/ql-request.dto";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";

@Component({
    selector: 'tm-my-tickets',
    templateUrl: './tm-my-tickets.component.html',
    standalone: false
})
export class TmMyTicketsComponent
  implements OnInit, OnChanges, OnDestroy {

  protected initialized: boolean = false;
  protected busy: boolean = false;
  activeTabIndex: number = 0;
  allTicketAssign: WidgetData;
  allTicketCreate: WidgetData;
  loggedOnAgent: AgentDto;
  allTicketCloseCreate: WidgetData;
  assignedClosedTicketsWidget: WidgetData;
  disableUpdate: boolean = true;

  constructor(protected ticketService: TicketService, protected agentService: AgentService, protected navigationService: MvsObjectNavigationService) {
  }


  ngOnInit() {
    this.getLoggedOnAgent();

    this.initialized = true;
  }

  getLoggedOnAgent() {
    this.agentService.me().subscribe(res => {
      this.loggedOnAgent = res;
      this.refreshAssignTickets();
        this.refreshAllTickets();
        this.refreshCloseCreateTicketWidget();
      // this.refreshAssignedCloseTicketsWidget();
    });
  }


  refreshAssignTickets() {
    const filterCriteriaList: FilterCriteria[] = [];

    // filterCriteriaList.push(FilterCriteria.create('e.createdBy', FilterCriteria.cOperatorEqual, '${E:ME_USERNAME}', null));
    filterCriteriaList.push(FilterCriteria.create('e.assigneeAgentId', FilterCriteria.cOperatorEqual, this.loggedOnAgent.id))

    const sorting: Sorting[] = [new Sorting("e.dueDate", true)];
    // this.ticketService.includeTicketStatusOpenToFilter(filterCriteriaList);


      const alias = "consultant.agent.open.tickets.new";

      const qlRequest: QlRequestDto = this.getqlQuery(alias, filterCriteriaList,sorting)

      this.allTicketAssign = WidgetFactory.createWidgetList(
          alias,
          'Meine Tickets',
          'table',
          'list',
          'ql',
          'tm.Ticket',
          'No tickets found!',
          qlRequest
      );

    // Check if the device is mobile and set uiComponent accordingly
    const currentRoute = window.location.href;
    const isMobile = currentRoute.includes('/mobile/');
    if (isMobile) {
      this.allTicketAssign.idAlias = 'list.' + this.allTicketAssign.idAlias;
      this.allTicketAssign.uiComponent = 'list';
    }

  }

  refreshAllTickets() {
    const filterCriteriaList: FilterCriteria[] = [];

    filterCriteriaList.push(FilterCriteria.create('e.createdBy', FilterCriteria.cOperatorEqual, '${E:ME_USERNAME}', null));

    const sorting: Sorting[] = [new Sorting("e.dueDate", true)];
    // this.ticketService.includeTicketStatusClosedToFilter(filterCriteriaList);

      const alias = "consultant.agent.close.tickets.new";

      const qlRequest: QlRequestDto = this.getqlQuery(alias, filterCriteriaList,sorting)

      this.allTicketCreate = WidgetFactory.createWidgetList(
          alias,
          'Meine erstellten Tickets',
          'table',
          'list',
          'ql',
          'tm.Ticket',
          'No tickets found!',
          qlRequest
      );

    const currentRoute = window.location.href;
    const isMobile = currentRoute.includes('/mobile/');
    if (isMobile) {
      this.allTicketCreate.idAlias = 'list.' + this.allTicketCreate.idAlias;
      this.allTicketCreate.uiComponent = 'list';
    }

  }

  refreshCloseCreateTicketWidget() {
    const filterCriteria = [FilterCriteria.create('e.createdBy', FilterCriteria.cOperatorEqual, '${E:ME_USERNAME}', null)];
    const sorting: Sorting[] = [new Sorting("e.dueDate", true)];
      this.ticketService.includeTicketStatusClosedToFilter(filterCriteria);
      const alias = "consultant.agent.assigned.tickets.new";

      const qlRequest: QlRequestDto = this.getqlQuery(alias, filterCriteria,sorting)

      this.allTicketCloseCreate = WidgetFactory.createWidgetList(
          alias,
          'Geschlossene Tickets',
          'table',
          'list',
          'ql',
          'tm.Ticket',
          'No tickets found!',
          qlRequest
      );
  }


    handleTicketSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry("tm.Ticket", event.objectId, null, "Ticket", null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'right');
    }

    getqlQuery(alias:string,filterCriteriaList:FilterCriteria[],sorting:Sorting[]): QlRequestDto{

        const qlQuery: QlQueryDto = this.ticketService.ticketManagementQlQuery(alias, filterCriteriaList, sorting);


        const pipe: QlExportPipeDto = {
            name: alias,
            type: "view",
            simpleQuery: alias,
            settings: {
                includeForm: true,
                includeCount: true,
                resolveEnums: "ordinal"
            }
        };

        const request = new QlRequestDto();
        request.queries = [qlQuery];
        request.pipes = [pipe];

        return request;
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngOnDestroy() {
    }
}
